var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9271 2.66589L8.48599 7.61542L3.02431 8.41168C2.04488 8.55373 1.65235 9.76121 2.36263 10.4528L6.31403 14.3033L5.37945 19.7425C5.21123 20.7257 6.24674 21.4621 7.11403 21.0023L12 18.4341L16.886 21.0023C17.7533 21.4584 18.7888 20.7257 18.6205 19.7425L17.686 14.3033L21.6374 10.4528C22.3476 9.76121 21.9551 8.55373 20.9757 8.41168L15.514 7.61542L13.0729 2.66589C12.6355 1.78365 11.3682 1.77244 10.9271 2.66589Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.7587ed4ac954e021e0554d3b12b506cd.svg";
export { ForwardRef as ReactComponent };